module.exports = __webpack_public_path__ + "static/media/wyb6b.339dc89b.mp4";